import { gql } from '@apollo/client'
import { IQueryBasicData } from '../IQueryData'

export interface ISetParkingPoolUserDataData {
  setParkingPoolUserData: IQueryBasicData
}

export interface ISetParkingPoolUserDataVars {
  login: string
  carPlate?: string
  carPlate2?: string
  enabled?: boolean
}

export const SET_PARKING_POOL_USER_DATA = gql`
  mutation setParkingPoolUserData(
    $login: String!
    $carPlate: String
    $carPlate2: String
    $enabled: Boolean
  ) {
    setParkingPoolUserData(
      login: $login
      car_plate: $carPlate
      car_plate_2: $carPlate2
      enabled: $enabled
    ) {
      status
      code
      error
      message
    }
  }
`
